// IMPORTANT: When adding a new country verify that the translated text exists.

// Used: KyC level 1 - add bank account.
// IMPORTANT: When adding a new country, check if the telephone code for that country has already been added (countryPhoneCodes).
export const operatingCountries = [
  'AR',
  'BO',
  'BR',
  'CL',
  'CR',
  'CO',
  'EC',
  'GT',
  'ID',
  'MX',
  'MY',
  'PA',
  'PE',
  'PY',
  'US',
  'UY',
  'ES',
];

// Used: Create payment link - Create payment button - add payment methods (Filter).
export const allCountries = ['AR', 'BO', 'BR', 'CL', 'CO', 'CR', 'EC', 'GT', 'ID', 'MX', 'MY', 'PE', 'PY', 'UY'];

export const countriesByRegions = {
  // América Latina
  LA: ['AR', 'BO', 'BR', 'CL', 'CO', 'CR', 'EC', 'GT', 'MX', 'PE', 'PY', 'UY'],
  // África y Medio Oriente
  AF_ME: [],
  // Asia
  AS: ['ID', 'MY'],
};

// Used: Subscription
export const subscriptionCountries = ['BR', 'CL', 'CO', 'MX', 'PE', 'UY'];

// Used: kyc level 1
export const countryPhoneCodes = {
  AR: '+54',
  BO: '+591',
  BR: '+55',
  CL: '+56',
  CO: '+57',
  CR: '+506',
  EC: '+593',
  ES: '+34',
  GT: '+502',
  ID: '+62',
  MX: '+52',
  MY: '+60',
  PA: '+507',
  PE: '+51',
  PY: '+595',
  US: '+1',
  UY: '+598',
};

export const functionalCurrenciesByCountry = {
  AR: 'ARS',
  BO: 'BOB',
  BR: 'BRL',
  CL: 'CLP',
  CO: 'COP',
  CR: 'CRC',
  EC: 'USD',
  ES: 'EUR',
  GT: 'GTQ',
  ID: 'IDR',
  MX: 'MXN',
  MY: 'MYR',
  PA: 'USD',
  PE: 'PEN',
  PY: 'PYG',
  US: 'USD',
  UY: 'UYU',
};

// IMPORTANT: When adding a new currency verify that the translated text exists.
export const functionalCurrencies = Object.values(functionalCurrenciesByCountry);

export default {
  refreshToken: 300000, // Milliseconds
  emailValidationOnSignUp: true,
  uloadFileLogoMaxSize: 2, // MegaBytes
  uloadFileMaxSize: 10, // MegaBytes
  uloadFileSupportedExtensions: ['pdf', 'png', 'jpeg', 'jpg', 'doc', 'docx'],
  uloadFileSupportedExtensionsForImages: ['png', 'jpeg', 'jpg'],
  lastLevelKYC: 4,
  minWithdrawalUSD: 10, // Without fee
  chargeWithdrawalUSD: 1, // Without fee
  daysToWithdrawLocalPMs: 3,
  daysToWithdrawCards: 7,
};
